import HashLoader from "react-spinners/HashLoader";
import LoadingOverlay from "react-loading-overlay";

type CustomLoadingOverlayProps = {
  active: boolean;
  text?: string;
  fullHeight?: boolean;
  children?: React.ReactNode;
};

const CustomLoadingOverlay = ({
  active,
  text,
  fullHeight,
  children,
}: CustomLoadingOverlayProps) => {
  return (
    <LoadingOverlay
      active={active}
      spinner={<HashLoader color="#222c4a" />}
      text={
        <p
          style={{
            maxWidth: "500px",
            marginTop: "30px",
            fontWeight: "bold",
            color: "#222c4a",
          }}
        >
          {text}
        </p>
      }
      styles={
        fullHeight
          ? {
              overlay: (base) => ({
                ...base,
                height: "100vh",
              }),
            }
          : {}
      }
    >
      {children}
    </LoadingOverlay>
  );
};

export default CustomLoadingOverlay;
